<template>
	<view class="oil_body">
		<view class="oil_header">请选择分油类型</view>
		<view class="sele_car">
			<view @tap="seleFn(1)"
				:style=" {zIndex: seleindex!=1?  '1':'',transform:seleindex!=1? 'scale(0.9)':'',backgroundColor: seleindex!=1?'#66AFFF':''} "
				class="car_itme car_itme_left">
				<view v-if="seleindex==1" class="car_body">
					<view class="car_itme_title">
						接收方:个人
					</view>
					<view class="img"></view>
					<view>企业对个人</view>
				</view>
				<view v-if="seleindex!=1" style="left: 0; position: absolute;" class="hideTip"></view>
			</view>
			<view @tap="seleFn(2)"
				:style="{zIndex: seleindex!=2?  '1':'',transform:seleindex!=2? 'scale(0.9)':'',backgroundColor: seleindex!=2?'#66AFFF':''}"
				class="car_itme car_itme_right">
				<view v-if="seleindex==2" class="car_body">
					<view class="car_itme_title">
						接收方:企业
					</view>
					<view class="img"></view>
					<view>企业对企业</view>
				</view>
				<view v-if="seleindex!=2" style="right: 0; position: absolute;" class="hideTip"></view>
			</view>
		</view>

		<view class="sele_Bar">
			<view
				:style="{transform: barIndex==2?  'translateX( calc(100% - 20rpx)   )' :'' ,background:barIndex==2?  '#EC4645' :'' }"
				class="move_item"></view>
			<view @tap="seleBarFn(1)" :style="{color:barIndex==1? 'white' : ''}" class="sele_Bar_item">分油</view>
			<view @tap="seleBarFn(2)" :style="{color:barIndex==2? 'white' : ''}" class="sele_Bar_item">圈回</view>
		</view>
		<view class="oli_list">
			<view class="oli_list_item">
				<view class="oli_list_item_body">
					<view class="oli_list_item_body_left">
						<view class="oli_list_item_body_left_img" >
						</view>
						<view>发起方</view>
					</view>
					<view>></view>
				</view>
			</view>
			<view class="oli_list_item">
				<view class="oli_list_item_body">
					<view class="oli_list_item_body_left">
						<view class="oli_list_item_body_left_img" >
						</view>
						<view>发起方</view>
					</view>
					<view>></view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				seleindex: 1,
				barIndex: 1,
				transition: {
					zIndex: '1',
					// height: '323rpx',
					// width: '397rpx',
					transform: "scale(0.9)",
					backgroundColor: '#66AFFF'
				}
			}
		},
		methods: {
			seleBarFn(e) {
				this.barIndex = e
			},
			seleFn(e) {
				this.seleindex = e
			}
		}
	}
</script>

<style>
	.oli_list_item_body_left_img {
		width: 80rpx;
		height: 73rpx;
		background-color: #007AFF;
		margin-right: 33rpx;
	}

	.oli_list_item_body_left {
		display: flex;
		align-items: center;
	}

	.oli_list_item_body {
		border-bottom: 1px #F0F2FF solid;
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 20rpx;
		/* padding: 20rpx 0; */

	}

	.oli_list_item {
		flex: 1;
		padding: 0 20rpx;
	}

	.oli_list {
		height: 333rpx;
		background: #FFFFFF;
		border-radius: 20rpx;
		display: flex;
		flex-direction: column;
	}

	.img {
		width: 100%;
		height: 81rpx;
		margin-top: 43rpx;
		margin-bottom: 30rpx;
	}

	.car_body {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.move_item {
		position: absolute;
		left: 10rpx;
		width: 50%;
		height: 60rpx;
		background: #2866FF;
		border-radius: 10rpx;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #999999;
		z-index: 0;
		transition: all .3s;
	}

	.sele_Bar_item {

		/* width: 287rpx; */
		flex: 1;
		height: 60rpx;
		/* background: #2866FF; */
		border-radius: 10rpx;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #999999;
		z-index: 1;
		transition: color .4s;
	}

	.sele_Bar {
		/* background-color: #18B566; */
		margin: 31rpx 40rpx;
		padding: 10rpx;
		display: flex;
		position: relative;
		background-color: #FFFFFF;
		border-radius: 10px;
	}

	.hideTip {
		background-color: #E43D33;
		width: calc(100% - (882rpx - (100vw - 62rpx)));
		/* width: calc( 100vw  - 62rpx - 441rpx ); */
		height: 100%;
	}

	.car_itme_right {
		right: 0;
		/* 	top:0;
		bottom: 0;
		margin: auto; */
	}

	.car_itme_left {
		left: 0;
		/* 	top:0;
		bottom: 0;
		margin: auto; */
	}

	.car_itme {
		/* opacity: .3; */
		height: 359rpx;
		width: 441rpx;
		border-radius: 20rpx;
		overflow: hidden;
		position: absolute;
		/* transition: width .4s,height .4s ,background .4s,z-index 0s ; */
		transition: transform .4s, background .8s;
		z-index: 2;
		background-color: #2866FF;
		box-shadow: 0px 3px 9px 0px rgba(88, 88, 88, 0.2);
		color: white;
		display: flex;
		justify-content: center;
	}

	.sele_car {
		margin-top: 25rpx;
		display: flex;
		flex-wrap: wrap;
		position: relative;
		height: 359rpx;
	}

	.oil_body {
		padding: 42rpx 31rpx;
	}

	.oil_header {
		font-size: 34rpx;
		font-family: PingFang SC;
		font-weight: bold;
		color: #333333;
	}
</style>
